import { defineMessages } from '@jutro/locale';

export default defineMessages({
    paymentProessed: {
        id: 'ml.gateway.views.account-detail.Your payment has been processed',
        defaultMessage: 'Your payment has been processed'
    },
    confirmation: {
        id: 'ml.gateway.views.account-detail.Confirmation',
        defaultMessage: 'Confirmation'
    },
    thankYou: {
        id: 'ml.gateway.views.account-detail.Thank you for your payment',
        defaultMessage: 'Thank you for your payment'
    },
    paymentMethodXEndingInX: {
        id: 'ml.gateway.views.account-detail.Payment method: x ending in x',
        defaultMessage: 'Payment method: {nickname} ending in {last4Digits}'
    },
    printConfirmation: {
        id: 'ml.gateway.views.account-detail.Print confirmation',
        defaultMessage: 'Print confirmation'
    },
    paymentConfirmaionNumber: {
        id: 'ml.gateway.views.account-detail.Payment confirmation #: x',
        defaultMessage: 'Payment confirmation #: {confirmationNumber}'
    },
    policyNumber: {
        id: 'ml.gateway.views.account-detail.Policy Number: x',
        defaultMessage: 'Policy Number: {policyNumber}'
    },
    paymentAmount: {
        id: 'ml.gateway.views.account-detail.Payment amount: x',
        defaultMessage: 'Payment amount: {amount}'
    },
    paymentDate: {
        id: 'ml.gateway.views.account-detail.Payment date: x',
        defaultMessage: 'Payment date: {date}'
    },
    paymentMethod: {
        id: 'ml.gateway.views.account-detail.Payment method: x ending in x',
        defaultMessage: 'Payment method: {method} ending in {last4Digits}'
    },
    reminder: {
        id: 'ml.gateway.views.account-detail.Reminder',
        defaultMessage: 'Reminder:'
    },
    reminderMessage: {
        id: 'ml.gateway.views.account-detail.ReminderMessage',
        defaultMessage: '{reminder} This will not change the bank account or credit/debit card you previously selected for scheduled payments. If you wish to update, you will need to change your payment method.'
    },
    paymentFail: {
        id: 'ml.gateway.views.account-detail.Your payment in the amount of x for policy y was not successful.',
        defaultMessage: 'Your payment in the amount of {amount} for policy {policyNumber} was not successful.'
    }
});